// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-add {
   background: darkgreen;
   color: white;
}

.input-name {
   margin-right: 15px;
}

.input-email {
   margin-right: 15px;
}

.hint {
   font-size: 12px;
   color: red;
}

.hint-none {
   display: none;
}

.hint-block {
   display: block;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/reassign-dialog/reassign-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,UAAU;AACb;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".btn-add {\n   background: darkgreen;\n   color: white;\n}\n\n.input-name {\n   margin-right: 15px;\n}\n\n.input-email {\n   margin-right: 15px;\n}\n\n.hint {\n   font-size: 12px;\n   color: red;\n}\n\n.hint-none {\n   display: none;\n}\n\n.hint-block {\n   display: block;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
